
import { useState } from 'react';
import { Check } from 'lucide-react';

const GreenClubScreen = ({ setActiveScreen }) => {
  const [hoveredPlan, setHoveredPlan] = useState(null);
  
  const plans = [
    {
      id: 'mensal',
      title: 'Plano Mensal',
      price: 'R$ 29,90',
      period: '/mês',
      features: [
        'Acesso a todos os conteúdos',
        'Suporte por e-mail',
        'Cancelamento a qualquer momento'
      ],
      popular: false
    },
    {
      id: 'trimestral',
      title: 'Plano Trimestral',
      price: 'R$ 79,90',
      period: '/trimestre',
      features: [
        'Acesso a todos os conteúdos',
        'Suporte prioritário',
        'Desconto de 10% em relação ao mensal',
        'Cancelamento a qualquer momento'
      ],
      popular: true
    },
    {
      id: 'anual',
      title: 'Plano Anual',
      price: 'R$ 269,90',
      period: '/ano',
      features: [
        'Acesso a todos os conteúdos',
        'Suporte VIP 24/7',
        'Desconto de 25% em relação ao mensal',
        'Acesso a conteúdos exclusivos',
        'Cancelamento a qualquer momento'
      ],
      popular: false
    }
  ];

  return (
    <div className="min-h-screen bg-green-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-green-800 mb-2">Escolha seu plano</h1>
          <p className="text-lg text-green-700">Comece agora mesmo e tenha acesso ao melhor conteúdo</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`rounded-xl overflow-hidden shadow-lg transition-all duration-300 transform flex flex-col justify-between ${
                hoveredPlan === plan.id ? 'scale-105' : ''
              } ${
                plan.popular ? 'border-2 border-green-500 ring-2 ring-green-400' : 'border border-green-200'
              } bg-white`}
              onMouseEnter={() => setHoveredPlan(plan.id)}
              onMouseLeave={() => setHoveredPlan(null)}
            >
              {plan.popular && (
                <div className="bg-green-500 text-white text-center py-1 font-semibold">
                  Mais Popular
                </div>
              )}
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-green-800 mb-4">{plan.title}</h3>
                <div className="flex items-baseline mb-6">
                  <span className="text-4xl font-extrabold text-green-700">{plan.price}</span>
                  <span className="text-green-600 ml-1">{plan.period}</span>
                </div>
                
                <div className="border-t border-green-100 pt-6 pb-4">
                  <ul className="space-y-3">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <Check size={20} className="text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                        <span className="text-green-800">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div className="px-6 pb-6">
                <button 
                  className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
                    plan.popular 
                      ? 'bg-green-600 hover:bg-green-700 text-white' 
                      : 'bg-green-100 hover:bg-green-200 text-green-800'
                  }`}
                >
                  Assinar agora
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GreenClubScreen;
